import React from 'react';

// Error boundary around ChatDagCanvas so a node-render crash (null
// content from the LLM, a missing field on a new tool shape, a
// ReactFlow internal error, etc.) renders a fallback notice and
// leaves the rest of the right-column — including the Tools Panel —
// fully operational.
//
// Added after session 7's PeerNode `body.slice is not a function`
// crash took down the whole DAG tab. Alan's verdict: "unacceptable
// to have a browser crash homey." This boundary localizes the blast
// radius.

interface State {
  hasError: boolean;
  message: string;
}

export class ChatDagErrorBoundary extends React.Component<
  React.PropsWithChildren<unknown>,
  State
> {
  state: State = { hasError: false, message: '' };

  static getDerivedStateFromError(e: Error): State {
    return { hasError: true, message: e.message };
  }

  componentDidCatch(e: Error, info: React.ErrorInfo): void {
    // eslint-disable-next-line no-console
    console.error('[ChatDag] render error', e, info);
  }

  render(): React.ReactNode {
    if (this.state.hasError) {
      return (
        <div className="p-4 text-xs opacity-70 h-full flex flex-col items-center justify-center text-center">
          <div className="font-semibold mb-1">DAG unavailable</div>
          <div className="opacity-80 font-mono text-[10px] max-w-md break-words">
            {this.state.message}
          </div>
          <div className="mt-2 opacity-60">
            Tools tab still works. Refresh the page to retry.
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ChatDagErrorBoundary;
